<div
  class="modal fade"
  id="signModel"
  tabindex="-1"
  aria-labelledby="signModelLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered sign-modal-dialog">
    <div class="modal-content sign-modal">
      <!-- Header -->
      <div class="sign-modal__header">
        <div class="sign-modal__title-row">
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#6c2bd9"
            stroke-width="2"
          >
            <path d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25z" />
            <path
              d="M20.71 7.04a1 1 0 000-1.41l-2.34-2.34a1 1 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
            />
          </svg>
          <h4 class="sign-modal__title" id="signModelLabel">
            Choose Your Signature
          </h4>
        </div>
        <button type="button" class="sign-modal__close" data-bs-dismiss="modal">
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Body -->
      <div class="sign-modal__body">
        <!-- Name input -->
        <div class="sm-name-row">
          <label class="sm-label"
            >Name &amp; Signature <span class="req">*</span></label
          >
          <input
            class="sm-input"
            type="text"
            maxlength="50"
            [(ngModel)]="signatoryName"
            (input)="onNameChange()"
            (ngModelChange)="onNameChange()"
            placeholder="Enter your name"
          />
        </div>

        <!-- Tab buttons -->
        <ul class="sm-tabs" role="tablist">
          <li>
            <button
              class="sm-tab active"
              (click)="signOption = 'select'"
              data-bs-toggle="tab"
              data-bs-target="#sm-select"
              type="button"
              role="tab"
            >
              Select Style
            </button>
          </li>
          <li>
            <button
              class="sm-tab"
              (click)="signOption = 'draw'; initSignaturePad()"
              data-bs-toggle="tab"
              data-bs-target="#sm-draw"
              type="button"
              role="tab"
            >
              Draw
            </button>
          </li>
          <li>
            <button
              class="sm-tab"
              (click)="signOption = 'upload'"
              data-bs-toggle="tab"
              data-bs-target="#sm-upload"
              type="button"
              role="tab"
            >
              Upload
            </button>
          </li>
        </ul>

        <!-- Tab content -->
        <div class="tab-content">
          <!-- SELECT STYLE -->
          <div class="tab-pane fade show active" id="sm-select" role="tabpanel">
            <div class="style-grid">
              <label
                class="style-opt"
                *ngFor="
                  let s of [
                    { style: 'Brush Script MT' },
                    { style: 'Comic Sans MS' },
                    { style: 'Courier New' },
                    { style: 'Impact' }
                  ]
                "
              >
                <input
                  type="radio"
                  name="styleOpt"
                  class="style-radio"
                  (click)="selectTextSign('Name', s.style)"
                />
                <span
                  class="style-preview"
                  [style.fontFamily]="s.style"
                  [style.fontStyle]="'italic'"
                >
                  {{ signatoryName || "Your Name" }}
                </span>
              </label>
            </div>
            <div class="style-preview-row">
              <div class="style-preview-box" *ngIf="imageStyle">
                <img
                  [src]="imageStyle"
                  alt="Preview"
                  class="style-preview-img"
                />
              </div>
              <div class="font-pick-wrap">
                <label class="sm-label">Font Family</label>
                <app-dropdown
                  class="custom-dropdown"
                  [options]="signStyle"
                  [(ngModel)]="selectedStyle"
                  (onChange)="getStyleType()"
                  placeholder="Select Font"
                  optionLabel="name"
                  optionValue="code"
                  [autoDisplayFirst]="false"
                >
                  <ng-template let-opt pTemplate="item">
                    <span [style]="{ font: opt.code, 'font-size': '14px' }">{{
                      opt.name
                    }}</span>
                  </ng-template>
                </app-dropdown>
              </div>
            </div>
          </div>

          <!-- DRAW -->
          <div class="tab-pane fade" id="sm-draw" role="tabpanel">
            <div class="draw-wrap">
              <canvas
                #signPadCanvas
                id="signPadCanvasPortal"
                class="sign-canvas"
                width="640"
                height="140"
              >
              </canvas>
              <button class="undo-btn" (click)="undoSign()">Undo</button>
            </div>
          </div>

          <!-- UPLOAD -->
          <div class="tab-pane fade" id="sm-upload" role="tabpanel">
            <div class="upload-wrap">
              <div class="upload-preview">
                <img
                  *ngIf="pdfSource"
                  [src]="pdfSource"
                  alt="Preview"
                  class="upload-preview-img"
                />
                <div *ngIf="!pdfSource" class="upload-placeholder">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#d1d5db"
                    stroke-width="1.5"
                  >
                    <path
                      d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
                    />
                    <path d="M14 2v6h6M12 12v6M9 15l3-3 3 3" />
                  </svg>
                  <span>No file selected</span>
                </div>
              </div>
              <div class="upload-controls">
                <p class="upload-hint">Accepted: JPEG, PNG, BMP — max 10 MB</p>
                <input
                  [hidden]="true"
                  type="file"
                  id="upload_file"
                  accept="image/jpeg,image/jpg,image/png,image/bmp"
                  (change)="onFileChange($event)"
                  #fileInput
                />
                <button class="upload-choose-btn" (click)="fileInput.click()">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                  >
                    <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  {{ fileName }}
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- /tab-content -->

        <!-- Legal text -->
        <p class="sign-legal">
          By selecting "Save", I acknowledge that the electronic representation
          of my signature holds the same legal weight as a traditional
          pen-and-paper signature for all legally binding documents.
        </p>

        <!-- Footer buttons -->
        <div class="sign-modal__footer">
          <button
            class="sm-btn sm-btn--clear"
            *ngIf="signOption !== 'select'"
            (click)="clearImage()"
          >
            Clear
          </button>
          <button class="sm-btn sm-btn--cancel" data-bs-dismiss="modal">
            Cancel
          </button>
          <button
            class="sm-btn sm-btn--save"
            data-bs-dismiss="modal"
            (click)="saveImage()"
            [disabled]="
              !signatoryDetails?.name || signatoryDetails.name.trim() === ''
            "
          >
            Save
          </button>
        </div>
      </div>
      <!-- /sign-modal__body -->
    </div>
  </div>
</div>

<ng-template #signatureWarning let-modal>
  <div class="modal-header custom-header text-white">
    <h4 class="modal-title mb-0">Signature Error</h4>
  </div>
  <div class="modal-body">
    <div class="d-flex align-items-center mb-2 text-danger">
      <strong>Signature is blank.</strong>
    </div>
    <p class="mb-1">Please sign the document before submitting.</p>
    <p class="mb-0">This screen will now refresh to allow you to try again.</p>
  </div>
  <div class="modal-footer">
    <button class="btn custom-btn" (click)="onSignatureWarningOk(modal)">
      <i class="pi pi-refresh me-1"></i> Okay
    </button>
  </div>
</ng-template>
